import * as React from 'react'
import { memo } from 'react'
const SvgArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 36 9"
  >
    <path
      fill="#fff"
      d="m0 3.96 28.08-.18C27 2.34 26.46 1.44 26.46 0c2.52 2.16 5.76 3.42 9.54 4.5-3.96 1.08-7.02 2.34-9.54 4.5a6.14 6.14 0 0 1 1.8-3.78L0 5.4Z"
    />
  </svg>
)
const Memo = memo(SvgArrowRight)
export default Memo
